import {
  isEmbedding,
  isPublicEmbedding,
  isStaticEmbedding,
} from "metabase/embedding/config";
import { PLUGIN_FEATURE_LEVEL_PERMISSIONS } from "metabase/plugins";
import type { Dataset } from "metabase-types/api";

/**
 * Semipublic: result downloads (CSV/XLSX/JSON) are disabled in the main web
 * app for every user, including admins. Public links and embeds keep their own
 * download toggles and are not affected.
 */
const isDownloadSurfaceAllowed = () =>
  isEmbedding() || isPublicEmbedding() || isStaticEmbedding();

export const canDownloadResults = (result?: Dataset) => {
  return (
    isDownloadSurfaceAllowed() &&
    !!result?.data &&
    !result.error &&
    PLUGIN_FEATURE_LEVEL_PERMISSIONS.canDownloadResults(result)
  );
};
